export interface MacStage {
  id: number;
  name: string;
  description: string;
}

export const MAC_STAGES: MacStage[] = [
  { 
    id: 1, 
    name: "Inception", 
    description: "Trends start here; exemplifying originality, they are mostly found in ethnic independents and fine dining" 
  },
  { 
    id: 2, 
    name: "Adoption", 
    description: "Still differentiated but have moved into upscale casual, fast casual, specialty grocery" 
  },
  { 
    id: 3, 
    name: "Proliferation", 
    description: "Adjusted for mainstream appeal; now available at casual chains, QSRs, mainline grocery" 
  },
  { 
    id: 4, 
    name: "Ubiquity", 
    description: "Trends at maturity; found across all segments of the food and beverage industry" 
  },
];

export const MAC_STAGE_DESCRIPTION = (
    <>The <strong>MAC</strong> (menu adoption cycle) helps to determine a trend's current life stage, as well as its potential for future advancement</>
);